var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"autocompleteInput",staticClass:"input_container",style:(_vm.customStyle),attrs:{"id":"autocomplete","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"focus":_vm.initAutocomplete,"click":_vm.undoDisabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }